import {
  Box,
  CircularProgress,
  Container,
  Divider,
  Grid,
  IconButton,
  Snackbar,
  Typography,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { ReportProblem } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import ChatBox from '../components/ChatBox';
import Commentation from '../components/discussion/Commentation';
import CommentationForm, {
  IHandler,
} from '../components/discussion/CommentationForm';
import Content from '../components/discussion/Content';
import Footer from '../components/Footer';
import Header from '../components/Header';
import PreFooter from '../components/PreFooter';
import Section from '../components/Section';
import ConfirmDialog from '../components/ConfirmDialog';
import {
  fetchDiscussion,
  submitComment,
  submitReply,
  submitReport,
} from '../services/discussion';
import { auth } from '../services/firebase';
import { cleanText } from '../services/rude-word';
interface IParams {
  id: string;
}

const useStyles = makeStyles({
  divider: { backgroundColor: '#564F70' },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

const Discussion = () => {
  const { id }: IParams = useParams();
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [data, setData] = useState<Discussion | undefined>();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const commentFormRef = useRef<IHandler | null>(null);
  const { divider, title } = useStyles();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showSnackbar, setShowSnackbar] = useState(false);

  const fetch = useCallback(async () => {
    const discussion = await fetchDiscussion(id);
    setData(discussion);
  }, [id]);
  useEffect(() => {
    fetch();
  }, [fetch]);
  const handleSubmitComment = async (content: string) => {
    if (auth.currentUser) {
      setSubmitting(true);
      const cleanMsg = await cleanText(content);
      const isCleanText = true; //old cleantext//await cleanText(content);
      if (isCleanText) {
        const comment: IComment = {
          content: cleanMsg,
          author: auth.currentUser.displayName ?? '',
          avatar: auth.currentUser.photoURL ?? '',
          uid: auth.currentUser.uid,
          createdAt: moment(),
          parentId: id,
          topicId: id,
        };

        await submitComment(comment);
        commentFormRef?.current?.clear();
        await fetch();
      } else {
        setShowSnackbar(true);
        setError('พบคำไม่เหมาะสม');
      }
      setSubmitting(false);
    }
  };
  const handleReply = async (
    parentId: string,
    value: string,
    hideInput: (success: boolean) => void
  ) => {
    if (auth.currentUser) {
      setSubmitting(true);
      const cleanMsg = await cleanText(value);
      const isCleanText = true; //old cleantext//await cleanText(value);
      if (!isCleanText) {
        setShowSnackbar(true);
        setError('พบคำไม่เหมาะสม');
        hideInput(false);
      } else {
        const comment: IComment = {
          content: cleanMsg,
          author: auth.currentUser.displayName ?? '',
          avatar: auth.currentUser.photoURL ?? '',
          uid: auth.currentUser.uid,
          createdAt: moment(),
          parentId,
          topicId: id,
        };
        await submitReply(comment);
        await fetch();
      }
      hideInput(isCleanText);
      setSubmitting(false);
    }
  };
  const handlesubmitReport = async () => {
    setLoading(true);
    await submitReport(id);
    setLoading(false);
    setOpenConfirm(false);
    setSuccess('Report สำเร็จ');
  };
  return (
    <>
      <Header />
      <Container maxWidth="md">
        <Section>
          <Box height={16} />
          <Grid container spacing={2}>
            <Grid item xs={12} md={8} className={title}>
              <Typography variant="h6">
                {data ? data.topic.title : ''}
              </Typography>
              {data && (
                <IconButton
                  style={{ color: '#F3F344' }}
                  onClick={() => setOpenConfirm(true)}
                >
                  <ReportProblem />
                </IconButton>
              )}
            </Grid>
            <Grid item xs={12} md={8}>
              {data ? (
                <>
                  <Box
                    display="flex"
                    bgcolor="#564F70"
                    flexDirection="column"
                    mb={1}
                  >
                    <Content data={data?.topic} />
                    <Divider />
                    {auth.currentUser ? (
                      <CommentationForm
                        avatar={auth.currentUser?.photoURL ?? ''}
                        ref={commentFormRef}
                        onSubmit={handleSubmitComment}
                        submitting={submitting}
                      />
                    ) : (
                      <Box
                        height={50}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Typography>เข้าสู่ระบบเพื่อตอบกลับ</Typography>
                      </Box>
                    )}
                  </Box>
                  <Box
                    display="flex"
                    bgcolor="#564F70"
                    flexDirection="column"
                    p={2}
                  >
                    <Typography>{data.topic.commentCount} คำตอบ</Typography>
                  </Box>
                  {data.comments.map((commentation, index) => (
                    <div key={`comment-${index}`}>
                      {index !== 0 && <Divider className={divider} />}
                      <Commentation
                        reply={auth.currentUser !== null}
                        onReply={handleReply}
                        commentation={commentation}
                      />
                    </div>
                  ))}
                </>
              ) : (
                <Box
                  display="flex"
                  bgcolor="#564F70"
                  flexDirection="column"
                  alignItems="center"
                  mb={1}
                  p={2}
                >
                  <CircularProgress color="secondary" />
                </Box>
              )}
            </Grid>
            <Grid item xs={12} md={4}>
              <ChatBox />
            </Grid>
          </Grid>
        </Section>
      </Container>
      <ConfirmDialog
        open={openConfirm}
        title={'รายงานกระทู้'}
        content={'คุณยืนยันที่จะรายงานกระทู้นี้ใช่หรือไม่ ?'}
        onClose={() => setOpenConfirm(false)}
        onConfirm={handlesubmitReport}
        loading={loading}
      />
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setError('');
        }}
      >
        <Alert severity="error">{error}</Alert>
      </Snackbar>
      <Snackbar
        open={success != ''}
        autoHideDuration={3000}
        onClose={() => {
          setSuccess('');
        }}
      >
        <Alert severity="success">{success}</Alert>
      </Snackbar>
      <PreFooter />
      <Footer />
    </>
  );
};

export default Discussion;
